import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = ({ email, setEmail, handleSubscribe, subscribeError, fadeIn }) => {
  return (
    <motion.footer
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={fadeIn}
      className="w-full bg-black text-white p-6"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-start">
        <div className="flex flex-col items-start mb-6 sm:mb-0">
          <img src="/assets/medpredix-logo-white.svg" alt="Logo" className="h-14 w-auto mb-4" />
          <p className="text-sm text-gray-400 max-w-xs">
            MedPredix: AI-powered medical predictions for accurate and fast diagnosis. Join us to revolutionize healthcare!
          </p>
        </div>
        <div className="max-w-md w-full">
          <h2 className="text-4xl font-bold mb-4 text-center sm:text-left">Subscribe Now!</h2>
          <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full sm:w-3/4 p-3 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-500 text-black placeholder-gray-400"
              required
            />
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              type="submit"
              className="w-full sm:w-1/4 bg-white text-black p-3 rounded-lg hover:bg-gray-200 transition-colors duration-300 font-semibold"
            >
              Subscribe
            </motion.button>
          </form>
          {subscribeError && <p className="text-red-500 mt-4">{subscribeError}</p>}
        </div>
      </div>
      <br /><br />
      <ul className="flex justify-center space-x-8 mb-6">
        <li>
          <Link to="/#features" className="hover:text-purple-300 font-semibold transition-colors duration-300">
            Features
          </Link>
        </li>
        <li>
          <Link to="/#accuracy" className="hover:text-purple-300 font-semibold transition-colors duration-300">
            Accuracy
          </Link>
        </li>
        <li>
          <Link to="/#contact" className="hover:text-purple-300 font-semibold transition-colors duration-300">
            Contact Us
          </Link>
        </li>
      </ul>
      <p className="text-sm text-center">Powered by Hilyoon SRL © {new Date().getFullYear()}</p>
    </motion.footer>
  );
};

export default Footer;
